(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/share-coupon/assets/javascripts/share-coupon.js') >= 0) return;  svs.modules.push('/components/tipsen/share-coupon/assets/javascripts/share-coupon.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const ReactIcon = svs.ui.ReactIcon;
const useShareableCouponUrl = svs.components.tipsen.couponId.useShareableCouponUrl;
const analytics = svs.components.analytics;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const CouponQueryParams = svs.components.sport.tipsenShared.CouponQueryParams;
const selectCouponStatus = svs.components.tipsen.engine.selectors.couponSelectors.selectCouponStatus;
const COUPON_VALID = svs.components.tipsen.engine.constants.couponStatus.COUPON_VALID;
const _svs$components$tipse = svs.components.tipsen.shareCoupon,
  ShareButton = _svs$components$tipse.ShareButton,
  ShareStatus = _svs$components$tipse.ShareStatus;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const shareConfig = {
  title: 'Spela hos Svenska Spel S&C',
  text: "Spela hos Svenska Spel S&C"
};
const shareMessages = {
  [ShareStatus.CopiedToClipboard]: 'Länken är kopierad, dela den med dina vänner',
  [ShareStatus.CopiedToClipboardFallback]: 'Länken är kopierad, dela den med dina vänner',
  [ShareStatus.Text]: 'Kopiera länken och dela den med dina vänner',
  [ShareStatus.Shared]: ''
};
const ShareCoupon = _ref => {
  let className = _ref.className,
    disabled = _ref.disabled;
  const isWideDevice = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  const couponId = useCouponId();
  const couponStatus = useSelector(state => selectCouponStatus(state, couponId));
  const isCouponValid = couponStatus === COUPON_VALID;
  const couponUrl = useShareableCouponUrl();
  disabled = disabled || !couponUrl;
  couponUrl && couponUrl.searchParams.set(CouponQueryParams.PARAM_SHARE, isCouponValid ? 'valid' : 'invalid');
  const trackOnClick = () => {
    analytics.trackEvent({
      category: 'Nya tipsen',
      action: 'Dela din kupong',
      opt_label: couponUrl.toString()
    });
  };
  return React.createElement(ShareButton, {
    className: className,
    disabled: disabled,
    isTransparent: true,
    onShare: trackOnClick,
    shareConfig: shareConfig,
    shareMessages: shareMessages,
    shareText: couponUrl ? couponUrl.toString() : null
  }, React.createElement(ReactIcon, {
    icon: "players",
    size: isWideDevice ? '300' : '100'
  }), "Dela kupong!");
};
setGlobal('svs.components.tipsen.shareCoupon.ShareCoupon', ShareCoupon);

 })(window);